import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from '../../store/app-slice/app';
import { handleNotificationVariant } from '../notifications/_common';
import { DeletePredictionResult, handleToggleDeletePredictionResult } from '../../store/mltester-slice/mltester';
import DeleteDialog from '../common/DeleteDialog';

const DeletePredictionResultDialog = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { deletingPredictionResult, deletePredicitionResultDialogOpen, deletePredicitionResultBodyParams } = useAppSelector((state: RootState) => state.mltester);
  
    function handleClose() {
        dispatch(handleToggleDeletePredictionResult({ isOpen: false, body: null }));
    }
  
    function handleSubmit() {
        dispatch(DeletePredictionResult(deletePredicitionResultBodyParams.id)).then((res : any) => {
                if(res && res.payload) { 
                    dispatch(enqueueSnackbar({ 
                        message: t(`${res.payload.message}`), 
                        options: { 
                            variant: handleNotificationVariant(res.payload.success),
                            persist: !res.payload.success
                        } 
                    }))
                }
            }
        );
    }
  
    if(!deletePredicitionResultBodyParams) return <></>;

    return(
        <DeleteDialog
            open={deletePredicitionResultDialogOpen} 
            title={t('DELETE_PREDICTION_RESULT_TITLE', { name: deletePredicitionResultBodyParams.name })} 
            bodyText={t('DELETE_PREDICTION_RESULT_BODY')} 
            isLoading={deletingPredictionResult} 
            onClose={function (reason?: string): void {
                handleClose();
            }} 
            onSubmit={function (): void {
                handleSubmit();
            }} 
            cancelButtonText={t('CANCEL_BUTTON')} 
            submitButtonText={t('SUBMIT_BUTTON')}
        />
    )
}

export default DeletePredictionResultDialog;